import includes from 'lodash/includes';

import { PeopleSecondaryMenuItems } from '../../CompactPeopleSecondaryMenu.types';

function getPeopleActiveMenu(
  pathname: string
): PeopleSecondaryMenuItems | null {
  if (includes(pathname, '/companies/grid/filters/blocked')) {
    return PeopleSecondaryMenuItems.BLOCKED_COMPANIES_GRID;
  }

  if (includes(pathname, '/companies/grid')) {
    return PeopleSecondaryMenuItems.COMPANIES_GRID;
  }

  if (includes(pathname, '/companies')) {
    return PeopleSecondaryMenuItems.COMPANIES;
  }

  if (includes(pathname, '/performers')) {
    return PeopleSecondaryMenuItems.PERFORMERS;
  }

  if (includes(pathname, '/clients')) {
    return PeopleSecondaryMenuItems.CLIENTS;
  }

  return null;
}

export default getPeopleActiveMenu;
